export enum OrgAssetStatusEnum {
  Synced = 0,
  Adding = 1,
  Updating = 2,
  Removing = 3
}
